<template>
  <div>
    <!-- TKP-153 / tunesoft2 s.3: üst başlık kalktı; sekmeler "Organizasyona Ait Varlıklar" / "Taslaklarım" / "Onayıma Sunulan Taslaklar".
         Sekmeler yalnız KVKK/GDPR'da ve onay süreci AÇIKKEN (TKP-102); üçüncü sekme yalnız onay yetkisi olan rollerde. -->
    <!-- TKP-233 m.141: sekmeler Görevler › Görevler görünümünde (nav-tab-menu) -->
    <b-tabs v-if="approvalTabVisible" nav-class="nav-tab-menu mb-3" lazy>
      <b-tab :title="$t('entity.organization')" active>
        <entity-boxes />
      </b-tab>
      <b-tab :title="$t('approval.mine-title')" data-test="approval-tab">
        <approval-tab />
      </b-tab>
      <b-tab v-if="approver" :title="$t('approval.submitted-title')" data-test="pending-tab">
        <approval-pending />
      </b-tab>
    </b-tabs>
    <entity-boxes v-else />
  </div>
</template>

<script>
import ApprovalPending from "@/modules/approval/approval-pending";
import ApprovalTab from "@/modules/approval/approval-tab";
import { approvalTabVisible } from "@/modules/approval/approval";
import EntityBoxes from "./component/entity-boxes";
export default {
  components: { EntityBoxes, ApprovalTab, ApprovalPending },
  data() {
    return { approvalStatus: null };
  },
  computed: {
    approvalTabVisible() {
      return approvalTabVisible(this.currentProduct, this.approvalStatus);
    },
    // onay rolü VEYA kendisine atanmış bekleyen paketi olan (ön onay birim kademesi, TKP-134) — backend `decider`
    approver() {
      return !!(this.approvalStatus && (this.approvalStatus.decider || this.approvalStatus.approver));
    },
  },
  async mounted() {
    if (!approvalTabVisible(this.currentProduct, { enabled: true })) return; // KVKK/GDPR dışı ürünlerde istek bile yok
    try {
      const { data } = await this.$store.dispatch("approval/status");
      this.approvalStatus = data;
      if (data && data.enabled) await this.$store.dispatch("approval/fetch"); // TKP-104: kutulardaki taslak/kilit rozetleri
    } catch (error) {
      this.approvalStatus = null; // okunamazsa sekme yok; Varlıklar bugünkü gibi
    }
  },
  beforeDestroy() {
    this.$store.commit("entityBoxes/clear");
  },
};
</script>

<style lang="scss" scoped>
@import url("./organization-entities-view.scss");
</style>
